$(document).ready(function(){

  $("#more-wrapp").click(function(){
    $('.less-wrapp').addClass("hide");
    $('.full-wrapp').addClass("active");
  });
  $("#less-wrapp").click(function(){
    $('.less-wrapp').removeClass("hide");
    $('.full-wrapp').removeClass("active");
  });
  
  
  /* collection JS*/
  $(".readmore_desc").click(function(){
      $(this).parents().addClass('hide');
      $(this).parents().next().addClass('show');
    });

  /* product JS*/


});


